import { combineReducers } from "redux";
import createFilterReducer from "../reducers/creators/filters";
import createListReducer from "../reducers/creators/list";
import { FILTERS, MEDIA_LIST_NAMESPACE } from "../../constants/store/mediaList";

export default combineReducers({
  filters: createFilterReducer(MEDIA_LIST_NAMESPACE, Object.values(FILTERS)),
  list: createListReducer(MEDIA_LIST_NAMESPACE, { pagination: { limit: 12 } }),
});
